import { render, staticRenderFns } from "./FieldDocumentlock.vue?vue&type=template&id=6fd9443c&scoped=true&"
import script from "./FieldDocumentlock.vue?vue&type=script&lang=js&"
export * from "./FieldDocumentlock.vue?vue&type=script&lang=js&"
import style0 from "./FieldDocumentlock.vue?vue&type=style&index=0&id=6fd9443c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9443c",
  null
  
)

export default component.exports